<template lang="pug">
  modal(@hide="$emit('hide')" width='500px' modal-class='u-bg-primary u-p3')
    div(slot='content' class='u-px4')
      h3(class='u-fz-h2 u-mt0 u-center u-line-1 u-mb4')
        span(class='u-white') Reserva un Pavill para&nbsp;
        span(class='u-color-secondary') Mujer Taxi

      input-validate(
        v-model='form.fullname', :rule='rules.fullname' name='fullname' icon='user' placeholder='Nombres y apellidos', :validation='toggleValidate'
        wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      input-validate(
        v-model='form.whatsapp', :rule='rules.whatsapp' name='whatsapp' icon='whatsapp' placeholder='Whatsapp', :validation='toggleValidate'
        wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      input-validate(
        v-model='form.descriptionService', :rule='rules.descriptionService'  placeholder='¿Desea especificar algún detalle del servicio?', :validation='toggleValidate' type='textarea'
        wrapper-class='c-input' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

      div(class='u-flex u-flex-wrap')
        div(class='c-input u-flex u-items-center u-mr3 u-mb3')
          input(id='specificTime' type='checkbox' class='u-mr2', v-model='form.specificTime')
          label(class='c-input__label u-color-text' for='specificTime') Especificar tiempo del servicio

        div(class='c-input u-flex u-items-center u-mb3')
          input(id='roundTrip' type='checkbox' class='u-mr2', v-model='form.roundTrip')
          label(class='c-input__label u-color-text' for='roundTrip') Ida y recojo

      input-validate(v-if='form.specificTime', :rule='rules.hours'
        v-model='form.hours' icon='clock' placeholder='¿Cuántas horas?' class='u-7/12@laptop u-8/12@tablet', :validation='toggleValidate'
        wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align' type='number' min='1')

      button(class='c-btn--primary u-12/12 u-fw-s-bold u-mb3 u-fz-h4 u-mt2' @click='postForm') Realizar Reserva
</template>

<script>
  import Validator from 'validatorjs'
  import axios from 'axios'

  export default {
    data () {
      return {
        toggleValidate: false,
        formValidate: false,
        isLoading: false,
        form: {
          fullname: '',
          whatsapp: '',
          descriptionService: '',
          roundTrip: false,
          specificTime: false,
          hours: null
        },
        rules: {
          fullname: 'required|name',
          whatsapp: 'required|phone',
          hours: ''
        }
      }
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarPedidoMujerTaxi.php`, this.form)
          axios.post(`${window.API_URL}/womantaxi`, this.form)
            .then((response) => {
              this.isLoading = false
              this.$emit('hide')
              this.$emit('success')
            })
            .catch(({response}) => {
              this.isLoading = false
              this.$emit('hide')
              this.$emit('error')
            })
        }
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.toggleValidate = !this.toggleValidate
        this.formValidate = validation.passes()
      }
    },

    watch: {
      'form.specificTime' (val) {
        if (val) {
          this.rules.hours = 'required|min:1'
        } else {
          this.form.hours = null
          this.rules.hours = ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/ModalWomanTaxi.vue